<template>
  <!-- 巡检维修-新增工单 -->
  <a-modal
    :title="title"
    :visible="showTubeView"
    :width="1100"
    destroyOnClose
    @ok="handleOk"
    @cancel="closeTubeView"
  >
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row
        class="form-row"
        type="flex"
        justify="center"
        :gutter="4"
      >
        <a-col
          v-if="Reassign"
          :md="12"
          :sm="24"
        >
          <a-form-model-item label="工单编号">
            <span v-if="!addOrUpdateForm.workNo">(系统自动生成)</span>
            <span v-else>{{ addOrUpdateForm.workNo }}</span>
            <!-- <a-input disabled v-model="addOrUpdateForm.workNo" placeholder="自动生成"></a-input> -->
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            v-if="Reassign"
            label="工单类型"
            prop="workOrderType"
          >
            <a-select
              placeholder="请选择工单类型"
              v-model="addOrUpdateForm.workOrderType"
            >
              <a-select-option
                v-for="item in OrderTypeList"
                :key="item.dictValue"
              >{{
                item.dictValue
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            v-if="Reassign"
            label="工单内容"
            prop="deviceName"
          >
            <a-input v-model="addOrUpdateForm.deviceName"  />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="负责人"
            prop="principal"
          >
            <a-select
              show-search
              option-filter-prop="children"
             
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
              @change="handleChange"
            >
              <a-select-option
                v-for="item in userlist"
                :key="item.id"
              >{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="计划开始时间"
            prop="startValue"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-date-picker
              v-model="addOrUpdateForm.startValue"
              :disabled-date="disabledStartDate"
              @change="onChanges"
              format="YYYY-MM-DD"
              @openChange="handleStartOpenChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="计划完成时间"
            prop="endValue"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
          >
            <a-date-picker
              v-model="addOrUpdateForm.endValue"
              :disabled-date="disabledEndDate"
              format="YYYY-MM-DD"
              :open="endOpen"
              @change="onChanget"
              @openChange="handleEndOpenChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
          v-if="Reassign"
        >
          <a-form-model-item
            label="是否需要停水事件"
            prop="isWaterOffEvent"
            :label-col="{ span: 9 }"
            :wrapper-col="{ span: 13 }"
          >
            <a-radio-group
              v-model="addOrUpdateForm.isWaterOffEvent"
              @change="WaterOffEventchange"
            >
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="是否关联停水事件"
            prop="isRelationWaterOffEvent"
            :label-col="{ span: 9 }"
            :wrapper-col="{ span: 13 }"
            v-if="WaterOf"
          >
            <a-radio-group
              v-model="addOrUpdateForm.isRelationWaterOffEvent"
              @change="WaterOffEvent"
            >
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <template v-if="addOrUpdateForm.isWaterOffEvent === 1">
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="模板选择"
              prop="templateId"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
            >
              <a-select
                v-model="addOrUpdateForm.templateId"
                placeholder="请选择短信模板"
                allow-clear
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in aliyunTemplateList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.templateName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="模板内容"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
            >
              <a-input
                :value="selectedTemplateContent"
                type="textarea"
                :rows="3"
                disabled
                placeholder="请先选择短信模板"
              />
            </a-form-model-item>
          </a-col>
        </template>
        <div v-if="WaterOf">
          <a-col
            :md="24"
            :sm="24"
            v-if="rOffEven"
          >
            <a-form-model-item
              label="关联停水事件"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="waterEventId"
            >
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.waterEventId"
                @change="waterEventchange"
              >
                <a-select-option
                  v-for="item in waterEven"
                  :key="item.id"
                >{{
                  item.eventName + item.eventNo
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="事件名称"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="eventName"
            >
              <a-input
                placeholder="请输入事件名称"
                v-model="addOrUpdateForm.eventName"
                :rows="3"
                :disabled="this.rOffEven"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item label="爆管管段">
              <a-button
                type="primary"
                @click="openMap"
              >选择爆管管段</a-button>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="停水管理员"
              prop="waterAdminId"
            >
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.waterAdminId"
                :disabled="this.rOffEven"
              >
                <a-select-option
                  v-for="item in userlist"
                  :key="item.id"
                >{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="开始分类编码"
              prop="startClassNo"
            >
              <a-input
                v-model="addOrUpdateForm.startClassNo"
                disabled
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="结束分类编码"
              prop="endClassNo"
            >
              <a-input
                v-model="addOrUpdateForm.endClassNo"
                disabled
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="12"
            :sm="24"
          >
            <a-form-model-item
              label="计划停水开始时间"
              prop="startValues"
            >
              <a-date-picker
                v-model="addOrUpdateForm.startValues"
                :disabled-date="disabledStartDates"
                @change="onChangehs"
                format="YYYY-MM-DD HH:mm:ss"
                @openChange="handleStartOpenChanges"
                :disabled="this.rOffEven"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="
              12"
            :sm="24"
          >
            <a-form-model-item
              label="计划停水结束时间"
              prop="endValues"
            >
              <a-date-picker
                v-model="addOrUpdateForm.endValues"
                :disabled-date="disabledEndDates"
                format="YYYY-MM-DD HH:mm:ss"
                :open="endOpens"
                @change="onChangets"
                @openChange="handleEndOpenChanges"
                :disabled="this.rOffEven"
              />
            </a-form-model-item>
          </a-col>
          <a-col
            :md="24"
            :sm="24"
          >
            <a-form-model-item
              label="事件描述"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              prop="describe"
            >
              <a-textarea
                :disabled="this.rOffEven"
                placeholder="多行输入"
                v-model="addOrUpdateForm.describe"
                :rows="3"
              />
            </a-form-model-item>
          </a-col>
        </div>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="位置"
            prop="place"
          >
            <a-button
              type="primary"
              @click="mapVisible = true"
            >维修地点</a-button>
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        > </a-col>
        <a-col
          :md="24"
          :sm="24"
        >
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
          >
            <a-input
              placeholder="请输入"
              v-model="addOrUpdateForm.place"
              style="margin-left: 93px"
            />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="24"
          :sm="24"
        >
          <a-form-model-item
            label="地址"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
            prop="maintainAddress"
          >
            <a-textarea
              :disabled="isUpdate"
              placeholder="请输入"
              v-model="addOrUpdateForm.maintainAddress"
              :rows="2"
            />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="协办人"
            prop="assistPersons"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }"
            style="margin-left: 37px"
          >
            <a-button
              @click="addSponsor"
              style="margin-right: 20px"
            >添加</a-button>
            <a-tag
              v-for="item in maintenancePersonsList"
              :key="item.key"
              closable
              @close="delSponsor(item.key)"
            >{{
              item.title
            }}</a-tag>
          </a-form-model-item>
        </a-col>
        <a-col
          :md="12"
          :sm="24"
        >
          <a-form-model-item
            label="督办人"
            prop="maintainPersons"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 20 }"
            style="margin-left: 37px"
          >
            <a-button
              @click="addSupervisor"
              style="margin-right: 20px"
            >添加</a-button>
            <a-tag
              v-for="item in maintainPersonsList"
              :key="item.key"
              closable
              @close="delMaintain(item.key)"
            >{{
              item.title
            }}</a-tag>
          </a-form-model-item>
        </a-col>


        <a-col
          :md="24"
          :sm="24"
        >
          <a-form-model-item
            label="备注"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 20 }"
          >
            <a-textarea
              placeholder="多行输入"
              v-model="addOrUpdateForm.remark"
              :rows="2"
            />
          </a-form-model-item>
        </a-col>
        <a-col
          :md="24"
          :sm="24"
        >
          <a-form-model-item
            label="附件上传"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 10 }"
            v-show="isUpdstl"
          >
            <a-upload-dragger
              name="file"
              :multiple="true"
              :customRequest="customRequest"
              :showUploadList="false"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">
                文件拖拽此处或
                <a>点击上传</a>
              </p>
            </a-upload-dragger>
            <div class="fileDiv">
              <a-row style="margin-top: 20px">
                <a-col :span="12">
                  <div class="fileDiv">
                    图片：
                    <ul>
                      <li
                        class="fileLi"
                        v-for="item in fileNamesimg"
                        :key="item.url"
                      >
                        <img
                          :src="item.url"
                          alt=""
                          style="width: 80px; height: 80px"
                          @click="clicimg(item.url)"
                        />
                      </li>
                    </ul>
                  </div>
                </a-col>
                <a-col :span="12">
                  <div class="fileDiv">
                    文件：
                    <ul>
                      <li
                        class="fileLi"
                        v-for="item in fileNamestex"
                        :key="item.url"
                      >
                        <div
                          class="uploadDiv"
                          @click="uploadFile(item)"
                        >
                          <a-icon
                            type="file-done"
                            style="cursor: pointer"
                          />
                          {{ item.name }}
                        </div>
                        <a-icon
                          type="delete"
                          style="float: right; cursor: pointer"
                          @click="deleteFile(item.url)"
                        />
                      </li>
                    </ul>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal
      ref="addModal"
      @addPepople="addPepople"
    ></addModal>
    <a-modal
      class="log-form"
      :title="'选取位置'"
      width="50%"
      v-model="showMap"
      @ok="closeMap"
      @cancel="closeMap2"
    >
      <input
        class="login-input"
        type="text"
        v-model="startLine"
        placeholder="请输入开始分类编码"
      />
      <input
        class="login-input"
        type="text"
        v-model="endLine"
        placeholder="请输入结束分类编码"
      />
      <a-button
        type="submit"
        @click="searchMapLine"
      >查询</a-button>
      <mapTemplate
        ref="waterMap"
        @childByValue="childByValue"
      ></mapTemplate>
    </a-modal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
import { getAliyunTemplates } from '@/api/aliyunSms'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
    mapTemplate
  },
  data () {
    return {
      mapVisible: false,
      dayjs,
      endOpen: false,
      endOpens: false,
      WaterOf: false,
      rOffEven: false,
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      queryOneUrl: '/pipe-network/work_order_managements',
      uploadUrl: '/manager/file/resources/upload',
      showTubeView: false,
      isUpdstl: true,
      showMap: false,
      id: '',
      startLine: '',
      endLine: '',
      addOrUpdateForm: {
        workNo: '',
        place: '',
        maintainAddress: '',
        startTime: '',
        endTime: '',
        deviceName: '',
        principal: '',
        workOrderType: '',
        remark: '',
        predictEtime: '',
        predictStime: '',
        maintenancePersons: [],
        maintainPersons: [],
        fileNames: [],
        endValue: '',
        startValue: '',
        startValues: '',
        endValues: '',
        isWaterOffEvent: 0,
        templateId: undefined,
        isRelationWaterOffEvent: 0,
        waterAdminId: '',
        waterEventId: '',
        waterAdminName: '',
        eventName: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        lineId: '',
        eventNo: ''
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      OrderTypeList: [], // 工单类型
      userlist: [],
      waterEven: [],
      aliyunTemplateList: [],
      maintenancePersonsList: [],
      maintainPersonsList: [],
      fileNamesimg: [],
      fileNamestex: [],
      selectButton: '',
      title: '新增',
      Reassign: true,
      isUpdate: false
    }
  },
  computed: {
    selectedTemplateContent () {
      if (!this.addOrUpdateForm.templateId) return ''
      const t = this.aliyunTemplateList.find(
        (item) => (item.templateCode || item.id) === this.addOrUpdateForm.templateId
      )
      return t ? (t.templateContent || '') : ''
    },
    rules () {
      return {
        deviceName: [{ required: true, message: '请输入工单内容', trigger: 'change' }],
        place: [{ required: true, message: '请选择维修地点', trigger: 'change' }],
        workOrderType: [{ required: true, message: '请选择工单类型', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        waterAdminId: [{ required: true, message: '请选择停水管理员', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        predictStime: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        predictEtime: [{ required: true, message: '请选择计划完成时间', trigger: 'change' }],
        maintainAddress: [{ required: true, message: '请输入地址', trigger: 'change' }],
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        startValues: [{ required: true, message: '请选择停水开始时间', trigger: 'change' }],
        endValues: [{ required: true, message: '请选择停水结束时间', trigger: 'change' }],
        waterEventId: [{ required: true, message: '请选择关联事件', trigger: 'change' }],
        describe: [{ required: true, message: '请输入事件描述', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }],
        templateId: [{
          required: true,
          validator: (rule, value, callback) => {
            if (this.addOrUpdateForm.isWaterOffEvent === 1 && !value) {
              callback(new Error('请选择短信模板'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      }
    }
  },
  created () {
    this.getUserList()
    this.getOrderTypeList()
  },
  methods: {
    childByValue (childValue) {
      this.startLine = childValue[0].properties.start_class_no
      this.endLine = childValue[0].properties.end_class_no
      this.addOrUpdateForm.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    openMap () {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
      this.startLine = this.addOrUpdateForm.startClassNo || ''
      this.endLine = this.addOrUpdateForm.endClassNo || ''
      this.showMap = true
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap () {
      this.addOrUpdateForm.endClassNo = this.endLine
      this.addOrUpdateForm.startClassNo = this.startLine
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2 () {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine () {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    disabledStartDates (current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDates (endValue) {
      const startValue = this.addOrUpdateForm.startValues
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChanges (open) {
      if (!open) {
        this.endOpens = true
      }
    },
    handleEndOpenChanges (open) {
      this.endOpens = open
    },
    onChangehs (date, dateString) {
      this.addOrUpdateForm.planStartTime = dateString
    },
    onChangets (date, dateString) {
      this.addOrUpdateForm.planEntTime = dateString
    },
    // 停水
    WaterOffEvent (value) {
      if (value.target.value == 1) {
        this.$http.get('/pipe-network/gis_water_events/binding/list').then((res) => {
          this.waterEven = res.data
          console.log(res.data)
        })
        this.rOffEven = true
      } else {
        this.rOffEven = false
        this.addOrUpdateForm.describe = ''
        this.addOrUpdateForm.eventName = ''
        this.addOrUpdateForm.waterAdminId = ''
        this.addOrUpdateForm.endClassNo = ''
        this.addOrUpdateForm.startClassNo = ''
        this.addOrUpdateForm.startValues = ''
        this.addOrUpdateForm.endValues = ''
        this.addOrUpdateForm.planStartTime = ''
        this.addOrUpdateForm.planEntTime = ''
        this.addOrUpdateForm.eventName = ''
        this.addOrUpdateForm.eventNo = ''
        this.addOrUpdateForm.waterEventId = ''
      }
    },
    waterEventchange (value) {
      console.log(value, 'diaia')
      this.$http.get(`/pipe-network/gis_water_events/${value}`).then((res) => {
        this.addOrUpdateForm.describe = res.data.describe
        this.addOrUpdateForm.eventName = res.data.eventName
        this.addOrUpdateForm.waterAdminId = res.data.waterAdminId
        this.addOrUpdateForm.endClassNo = res.data.endClassNo
        this.addOrUpdateForm.startClassNo = res.data.startClassNo
        this.addOrUpdateForm.startValues = res.data.planStartTime
        this.addOrUpdateForm.endValues = res.data.planEntTime
        this.addOrUpdateForm.planStartTime = res.data.planStartTime
        this.addOrUpdateForm.planEntTime = res.data.planEntTime
        this.addOrUpdateForm.eventNo = res.data.eventNo
      })
    },
    WaterOffEventchange (value) {
      if (value.target.value == 1) {
        this.WaterOf = true
        this.loadAliyunTemplates()
      } else {
        this.WaterOf = false
        this.addOrUpdateForm.templateId = undefined
      }
    },
    async loadAliyunTemplates () {
      try {
        const res = await getAliyunTemplates({ ispage:1 })
        const rows = res?.rows || []
        this.aliyunTemplateList = rows.flatMap((r) => r.aliyunTemplateVos || [])
      } catch (e) {
        console.error('加载阿里云短信模板失败:', e)
        this.aliyunTemplateList = []
      }
    },
    // 时间
    disabledStartDate (current) {
      // 11点22分
      return current && current < dayjs().startOf('day')
    },
    disabledEndDate (endValue) {
      const startValue = this.addOrUpdateForm.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    onChanges (value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
    },
    onChanget (value, dateString) {
      this.addOrUpdateForm.predictEtime = dateString + ' 00:00:00'
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        this.addOrUpdateForm.fileNames = []
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
            })
            .catch(() => { })
        }
      })
    },
    uploadFile (item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile (url) {
      const indexs = this.fileNamestex.findIndex((item) => {
        return item.url == url
      })
      this.fileNamestex.splice(indexs, 1)
      const index = this.addOrUpdateForm.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.addOrUpdateForm.fileNames.splice(index, 1)
    },
    customRequest (data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile (formData) {
      console.log(this.addOrUpdateForm.fileNames.length)

      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            // this.addOrUpdateForm.accessorys.push(response.data.url)
            const obj = {
              url: response.data.url,
              name: response.data.fileName
            }
            if (this.addOrUpdateForm.fileNames.length == 5) {
              this.$message.error('最多上传5个文件')
            } else {
              this.addOrUpdateForm.fileNames.push(obj)
              // this.addOrUpdateForm.fileNames.push(obj)
              var index = obj.url.lastIndexOf('.')
              var ext = obj.url.substr(index + 1)
              function isAssetTypeAnImage (ext) {
                return (
                  ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
                )
              }
              if (isAssetTypeAnImage(ext) == true) {
                this.fileNamesimg.push(obj)
                console.log(this.fileNamesimg, 'gggg')
              } else {
                this.fileNamestex.push(obj)
                console.log(this.fileNamestex, 'gggg')
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    handleMapOk (data) {
      this.addOrUpdateForm.maintainAddress = data.address
      this.addOrUpdateForm.place = data.point
      console.log(data.address, '位置')
    },
    moment,
    getOrderTypeList () {
      const params = {
        dictCode: 'CHECKING-THE-REPAIR-ORDER'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.OrderTypeList = data
      })
    },
    addSupervisor () {
      console.log(this.maintainPersonsList)
      this.selectButton = 'Supervisor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintainPersons)
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    addSponsor () {
      this.selectButton = 'Sponsor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintenancePersons)
    },
    addPepople (list) {
      if (this.selectButton == 'Sponsor') {
        this.maintenancePersonsList = list
        this.addOrUpdateForm.maintenancePersons = []
        list.length
          ? list.map((item) => {
            this.addOrUpdateForm.maintenancePersons.push(item.key)
          })
          : ''
      } else {
        this.maintainPersonsList = list
        this.addOrUpdateForm.maintainPersons = []
        list.length
          ? list.map((item) => {
            this.addOrUpdateForm.maintainPersons.push(item.key)
          })
          : ''
      }
    },
    delMaintain (key) {
      const i = this.maintainPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintainPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.maintainPersons.indexOf(key)
      this.addOrUpdateForm.maintainPersons.splice(j, 1)
    },
    delSponsor (key) {
      const i = this.maintenancePersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintenancePersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.maintenancePersons.indexOf(key)
      this.addOrUpdateForm.maintenancePersons.splice(j, 1)
    },
    handleChange (value) {
      this.addOrUpdateForm.principal = value
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    beginOnChange (value, dateString) {
      this.addOrUpdateForm.startTime = dateString
    },
    endOnChange (value, dateString) {
      this.addOrUpdateForm.endTime = dateString
    },
    _updateForm (real, data) {
      const keys = Object.keys(real)
      const dataKeys = Object.keys(data)
      const newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    ReassignHandle (id) {
      console.log(id, 'lll')
      this.showTubeView = true
      this.Reassign = false
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        startTime: '',
        endTime: '',
        deviceName: '',
        principal: '',
        workOrderType: '',
        remark: '',
        maintenancePersons: [],
        maintainPersons: [],
        fileNames: [],
        predictStime: '',
        predictEtime: '',
        endValue: '',
        startValue: '',
        maintainAddress: '',
        maintainAddress: '',
        place: '',
        describe: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        eventName: '',
        waterAdminId: '',
        endClassNo: '',
        startClassNo: '',
        startValues: '',
        endValues: '',
        planStartTime: '',
        planEntTime: '',
        eventName: '',
        eventNo: '',
        waterEventId: ''
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.title = '转派人员'
          this.isUpdate = true
          this.isUpdstl = false
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => { })
        }
      })
    },
    edit (id) {
      this.isUpdstl = true
      this.showTubeView = true
      this.Reassign = true
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        startTime: '',
        endTime: '',
        deviceName: '',
        principal: '',
        workOrderType: '',
        remark: '',
        describe: '',
        maintenancePersons: [],
        maintainPersons: [],
        maintainAddress: '',
        fileNames: [],
        predictStime: '',
        isRelationWaterOffEvent: 0,
        isWaterOffEvent: 0,
        templateId: undefined,
        waterAdminName: '',
        waterAdminId: '',
        waterEventId: '',
        predictEtime: '',
        endValue: '',
        startValue: '',
        place: '',
        describe: '',
        eventName: '',
        waterAdminId: '',
        endClassNo: '',
        startClassNo: '',
        startValues: '',
        endValues: '',
        planStartTime: '',
        planEntTime: '',
        eventName: '',
        eventNo: '',
        waterEventId: ''
      }
      this.title = '新增'
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.title = '编辑'
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              // 地下
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              if (this.addOrUpdateForm.isWaterOffEvent === 1) {
                this.WaterOf = true
                this.loadAliyunTemplates()
              }
              if (this.addOrUpdateForm.fileNames.length !== 0) {
                for (var i = 0; i < this.addOrUpdateForm.fileNames.length; i++) {
                  var index = this.addOrUpdateForm.fileNames[i].url.lastIndexOf('.')
                  var ext = this.addOrUpdateForm.fileNames[i].url.substr(index + 1)
                  function isAssetTypeAnImage (ext) {
                    return (
                      ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !==
                      -1
                    )
                  }
                  if (isAssetTypeAnImage(ext) == true) {
                    this.fileNamesimg.push(this.addOrUpdateForm.fileNames[i])
                  } else {
                    this.fileNamestex.push(this.addOrUpdateForm.fileNames[i])
                  }
                }
              }
              this.getPeopleList()
            })
            .catch(() => { })
        }
      })
    },
    // 获取数据
    getDataList () {
      this.dataListLoading = true
      const params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleOk (e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put']('/pipe-network/work_order_managements', {
            id: this.currentId,
            sysType: '巡检',
            ...this.addOrUpdateForm
          })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')

                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    closeTubeView () {
      this.fileNamesimg = []
      this.fileNamestex = []
      this.showTubeView = false
      this.WaterOf = false
      this.$refs.addOrUpdateForm.resetFields()
      this.maintenancePersonsList = []
      this.maintainPersonsList = []
      this.addOrUpdateForm.describe = ''
      this.$emit('handleOk')
    }
  }
}
</script>

<style lang="less" scoped>
.fileDiv {
  ul {
    list-style: 0;
    padding: 0;
    margin-left: 0;
  }
}
.fileLi {
  display: flex;
  align-items: center;
  // padding:0 10px;
  margin-top: 5px;
  justify-content: space-between;
  border-radius: 5px;
  .uploadDiv {
    cursor: pointer;
  }
}
.fileLi:hover {
  background: rgb(230, 247, 255);
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
</style>
